var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('package-card',{attrs:{"content":_vm.content}},[_c('info-link-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }